import { useEffect, useRef } from "react";

export const GlitchText = ({ children, className = "" }) => {
    const ref = useRef(null);
    useEffect(() => {
        const el = ref.current;
        if (!el) return;
        const onMove = (e) => {
            const r = el.getBoundingClientRect();
            const x = ((e.clientX - r.left) / r.width - 0.5) * 24;
            const y = ((e.clientY - r.top) / r.height - 0.5) * 12;
            el.style.setProperty("--gx", `${x}px`);
            el.style.setProperty("--gy", `${y}px`);
        };
        window.addEventListener("mousemove", onMove);
        return () => window.removeEventListener("mousemove", onMove);
    }, []);
    return (
        <div ref={ref} className={`relative select-none ${className}`} data-testid="glitch-text">
            <span className="relative z-10">{children}</span>
            <span aria-hidden className="absolute inset-0 text-[#5D3FD3] mix-blend-screen" style={{ transform: "translate(var(--gx,0), var(--gy,0))" }}>
                {children}
            </span>
            <span aria-hidden className="absolute inset-0 text-cyan-400 mix-blend-screen" style={{ transform: "translate(calc(var(--gx,0) * -1), calc(var(--gy,0) * -1))" }}>
                {children}
            </span>
        </div>
    );
};

export default GlitchText;
